import mock from "./mock"

import './apps/calendar'

mock.onAny().passThrough()
